import React, { lazy } from 'react';
import { adminMenu, crmMenu, demoPages, settingsMenu } from '../menu';
import AdminLogin from '../pages/presentation/auth/AdminLogin';
import Login from '../pages/presentation/auth/Login';
import FrontendOrderPage from '../pages/frontendOrder';
import CrmDashboard from '../pages/presentation/crm/CrmDashboard';
import NoPermission from '../pages/presentation/auth/NoPermission';
import AdminAlerts from '../pages/admin-alerts';
import ResetPassword from '../pages/presentation/auth/Reset';

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};

const CRM = {
	CUSTOMERS: lazy(() => import('../pages/customer')),
	ORDERS: lazy(() => import('../pages/order')),
	TAGS: lazy(() => import('../pages/tag')),
	ORDERDETAIL: lazy(() => import('../pages/orderDetail')),
	CUSTOMERDTAIL: lazy(() => import('../pages/customerDetail')),
	ORDERNEW: lazy(() => import('../pages/orderNew')),
	// FRONTENDORDER: lazy(() => import('../pages/frontendOrder')),
	PLAYGROUND: lazy(() => import('../pages/playground')),
	PRODUCTS: lazy(() => import('../pages/product')),
	AFFILIATE: lazy(() => import('../pages/affiliate')),
	RAMATEVERIFY: lazy(() => import('../pages/ramateVerify')),
	COMMISSIONMANAGE: lazy(() => import('../pages/ramate-admins/commision-manage')),
	SERVICENOTIFICATION: lazy(() => import('../pages/seviceNotification')),
	LOGISTICSPRODUCT: lazy(() => import('../pages/logisticsProduct')),
	COUPON: lazy(() => import('../pages/coupon')),
	USAGECHECK: lazy(() => import('../pages/usageCheck')),
	PROGMESSAGE: lazy(() => import('../pages/progMessageList/index')),
	PROGMESSAGE_DETAIL: lazy(() => import('../pages/progMessage/index')),
	PROSPECTCUSTOMER: lazy(() => import('../pages/prospect-customer')),
	PROSPECTCUSTOMERDETAIL: lazy(() => import('../pages/prospect-customer-detail')),
	LETTER: lazy(() => import('../pages/letter')),
	LETTERDETAIL: lazy(() => import('../pages/letterDetail')),
	LETTERHISTORY: lazy(() => import('../pages/letter-history')),
	CHARGESMS: lazy(() => import('../pages/charge-sms')),
};

const SETTINGS = {
	SETTING_MAIN_PAGE: lazy(() => import('../pages/settings')),
	ADMIN_SETTING_PAGE: lazy(() => import('../pages/admin-settings')),
};

const presentation = [
	/**
	 * CRM
	 */
	{
		path: '/',
		element: <CRM.ORDERS />,
		exact: true,
	},
	{
		path: crmMenu.products.path,
		element: <CRM.PRODUCTS />,
		exact: true,
	},
	{
		path: crmMenu.customers.path,
		element: <CRM.CUSTOMERS />,
		exact: true,
	},
	{
		path: adminMenu.usageCheck.path,
		element: <CRM.USAGECHECK />,
		exact: true,
	},

	{
		path: crmMenu.orders.path,
		element: <CRM.ORDERS />,
		exact: true,
	},
	{
		path: crmMenu.tags.path,
		element: <CRM.TAGS />,
		exact: true,
	},
	{
		path: `order-detail/:orderId`,
		element: <CRM.ORDERDETAIL />,
		exact: true,
	},

	{
		path: `customer-detail/:customerId`,
		element: <CRM.CUSTOMERDTAIL />,
		exact: true,
	},
	{
		path: 'order-new',
		element: <CRM.ORDERNEW />,
		exact: true,
	},
	{
		path: 'f/:orderId',
		element: <FrontendOrderPage />,
		exact: true,
	},
	{
		path: 'f/:orderId/:auto',
		element: <FrontendOrderPage />,
		exact: true,
	},
	{
		path: `${settingsMenu.affiliate.path}`,
		element: <CRM.AFFILIATE />,
		exact: true,
	},
	{
		path: `${adminMenu.ramateVerify.path}`,
		element: <CRM.RAMATEVERIFY />,
		exact: true,
	},
	{
		path: `${adminMenu.commissionManage.path}`,
		element: <CRM.COMMISSIONMANAGE />,
		exact: true,
	},
	{
		path: `${adminMenu.serviceNotification.path}`,
		element: <CRM.SERVICENOTIFICATION />,
		exact: true,
	},
	{
		path: `${crmMenu.logisticProduct.path}`,
		element: <CRM.LOGISTICSPRODUCT />,
		exact: true,
	},
	{
		path: `${crmMenu.coupon.path}`,
		element: <CRM.COUPON />,
		exact: true,
	},
	{
		path: `prog-message`,
		element: <CRM.PROGMESSAGE />,
		exact: true,
	},
	{
		path: `prog-message/:workflowId`,
		element: <CRM.PROGMESSAGE_DETAIL />,
		exact: true,
	},
	{
		path: `charge-sms`,
		element: <CRM.CHARGESMS />,
		exact: true,
	},
	/**
	 * Auth Page
	 */
	{
		path: '/no_permission',
		element: <NoPermission />,
		exact: true,
	},
	{
		path: demoPages.page404.path,
		element: <AUTH.PAGE_404 />,
		exact: true,
	},
	{
		path: demoPages.login.path,
		element: <Login />,
		exact: true,
	},
	{
		path: demoPages.signUp.path,
		element: <Login isSignUp />,
		exact: true,
	},
	{
		path: demoPages.reset.path,
		element: <ResetPassword />,
		exact: true,
	},

	/**
	 *
	 * CRM自製
	 *
	 */
	{
		path: '/prospect-customer',
		element: <CRM.PROSPECTCUSTOMER />,
		exact: true,
	},
	{
		path: '/prospect-customer-detail/:prospectCustomerId',
		element: <CRM.PROSPECTCUSTOMERDETAIL />,
		exact: true,
	},
	{
		path: '/letters',
		element: <CRM.LETTER />,
		exact: true,
	},
	{
		path: '/letters/new',
		element: <CRM.LETTERDETAIL />,
		exact: true,
	},
	{
		path: '/letter-detail/:letterTemplateId',
		element: <CRM.LETTERDETAIL />,
		exact: true,
	},
	{
		path: '/letter-history',
		element: <CRM.LETTERHISTORY />,
		exact: true,
	},

	{
		path: '/settings',
		element: <SETTINGS.SETTING_MAIN_PAGE />,
		exact: true,
	},
	{
		path: '/admin-settings',
		element: <SETTINGS.ADMIN_SETTING_PAGE />,
		exact: true,
	},
	{
		path: '/playground',
		element: <CRM.PLAYGROUND />,
		exact: true,
	},
	{
		path: '/admin/login',
		element: <AdminLogin />,
		exact: true,
	},
	{
		path: '/dashboard',
		element: <CrmDashboard />,
		exact: true,
	},
	{
		path: '/alerts',
		element: <AdminAlerts />,
		exact: true,
	},
];

const contents = [...presentation];

export default contents;
